import React from 'react';
import Link from 'components/consumer/Link';
const data = {
  FLAT_FEE: {
    rows: [{
      title: 'In home delivery, Price dependent on your zipcode',
      text: 'A premium in-home delivery service will deliver, move, unpack to the room of your choice and dispose of all packaging.',
      superscript: 1
    }, {
      title: 'Curbside Delivery',
      text: 'Our carriers will deliver your order to your front step or nearest building entrance',
      superscript: 2
    }, {
      title: 'Hold it for now, Free (of course)',
      text: 'Need more time? We can delay the production of your furniture so that it’s built and shipped when you’re ready.'
    }],
    terms: '[1] Shipping rates on decor items from our third-party vendors will vary. [2] Not available for all products and some exclusions apply.'
  },
  NINETY_DAYS_RETURNS: {
    rows: [{
      title: 'Canceling within 24 hours',
      text: 'Cancel within 24 hours of placing your order, and you will receive a full refund.'
    }, {
      title: 'Canceling after 24 hours & BEFORE shipment',
      text: 'Orders canceled after 24 hours after placing the order, but before it has been shipped, will receive a refund of the order’s subtotal, minus a 35% processing fee.'
    }, {
      title: 'Canceling after item has shipped, BEFORE delivery',
      text: 'Orders canceled after the order has been shipped, but before it has been delivered will receive a refund of the order’s subtotal, minus a 50% processing fee and shipping fees incurred.'
    }, {
      title: 'Furniture returns after delivery',
      text: `Once your furniture has been delivered, you have 90 days to send it back and receive a refund of the order’s subtotal, minus a 50% processing fee and shipping fees incurred.`,
      superscript: 1
    }, {
      title: '14-day returns (Accessories & decor)',
      text: 'Accessory cancellations are accepted within 48 hours of purchase, before the item ships. After that time cancellations are not available and our 14-day return policy applies. Please note: Wallpapers are final sale and cannot be returned. Accessories and decor items must be returned within 14 days of delivery to receive a refund of the order’s subtotal, minus a 25% restocking fee.',
      superscript: 2
    }, {
      title: 'Buy now, decide later',
      text: 'The Buy Now, Decide Later program gives you up to 90 days to choose a fabric for your order. If a fabric has not been chosen after 90 days, your order will be canceled and subject to a 10% cancellation fee.'
    }, {
      title: '90-day trial (mattress)',
      text: 'Our Joybird Luxury Mattresses come with a 90 day trial period starting at the date of delivery. If you decide the mattress is not right for you, please contact us to initiate the return process, which includes a full refund. We will work with you to arrange a return pick up through a local charity or recycling partner. 90-day trial excludes all sleeper sofa mattresses.',
      superscript: 3
    }],
    terms: '[1] Limited Edition and Clearance items are final sale and cannot be returned. [2] Wallpapers are final sale and cannot be returned. [3] No restocking fee.',
    footer: true
  },
  THIRTY_DAYS_RETURNS: {
    rows: [{
      title: 'Canceling within 24 hours',
      text: 'Cancel within 24 hours of placing your order, and you will receive a full refund.'
    }, {
      title: 'Canceling after 24 hours & BEFORE shipment',
      text: 'Orders canceled after 24 hours after placing the order, but before it has been shipped, will receive a refund of the order’s subtotal, minus a 35% processing fee.'
    }, {
      title: 'Canceling after item has shipped, BEFORE delivery',
      text: 'Orders canceled after the order has been shipped, but before it has been delivered will receive a refund of the order’s subtotal, minus a 50% processing fee and shipping fees incurred.'
    }, {
      title: 'Furniture returns after delivery',
      text: `Once your furniture has been delivered, you have 90 days to send it back and receive a refund of the order’s subtotal, minus a 50% processing fee and shipping fees incurred.`,
      superscript: 1
    }, {
      title: '14-day returns (Accessories & decor)',
      text: 'Accessory cancellations are accepted within 48 hours of purchase, before the item ships. After that time cancellations are not available and our 14-day return policy applies. Please note: Wallpapers are final sale and cannot be returned. Accessories and decor items must be returned within 14 days of delivery to receive a refund of the order’s subtotal, minus a 25% restocking fee.',
      superscript: 2
    }, {
      title: '90-day trial (mattress)',
      text: 'Our Joybird Luxury Mattresses come with a 90 day trial period starting at the date of delivery. If you decide the mattress is not right for you, please contact us to initiate the return process, which includes a full refund. We will work with you to arrange a return pick up through a local charity or recycling partner. 90-day trial excludes all sleeper sofa mattresses.',
      superscript: 3
    }],
    terms: '[1] Limited Edition and Clearance items are final sale and cannot be returned. [2] Wallpapers are final sale and cannot be returned. [3] No restocking fee.',
    footer: true
  },
  DAY_14_RETURNS: {
    rows: [{
      title: 'Canceling within 24 hours',
      text: 'Cancel within 24 hours of placing your order, and you will receive a full refund.'
    }, {
      title: 'Canceling after 24 hours & BEFORE shipment',
      text: 'Orders canceled after 24 hours after placing the order, but before it has been shipped, will receive a refund of the order’s subtotal, minus a 35% processing fee.'
    }, {
      title: 'Canceling after item has shipped, BEFORE delivery',
      text: 'Orders canceled after the order has been shipped, but before it has been delivered will receive a refund of the order’s subtotal, minus a 50% processing fee and shipping fees incurred.'
    }, {
      title: 'Furniture returns after delivery',
      text: `Once your furniture has been delivered, you have 90 days to send it back and receive a refund of the order’s subtotal, minus a 50% processing fee and shipping fees incurred.`,
      superscript: 1
    }, {
      title: '14-day returns (Accessories & decor)',
      text: 'Accessory cancellations are accepted within 48 hours of purchase, before the item ships. After that time cancellations are not available and our 14-day return policy applies. Please note: Wallpapers are final sale and cannot be returned. Accessories and decor items must be returned within 14 days of delivery to receive a refund of the order’s subtotal, minus a 25% restocking fee.',
      superscript: 2
    }, {
      title: '90-day trial (mattress)',
      text: 'Our Joybird Luxury Mattresses come with a 90 day trial period starting at the date of delivery. If you decide the mattress is not right for you, please contact us to initiate the return process, which includes a full refund. We will work with you to arrange a return pick up through a local charity or recycling partner. 90-day trial excludes all sleeper sofa mattresses.',
      superscript: 3
    }],
    terms: '[1] Limited Edition and Clearance items are final sale and cannot be returned. [2] Wallpapers are final sale and cannot be returned. [3] No restocking fee.',
    footer: true
  },
  FINAL_SALE: {
    paras: ['This product is final sale and cannot be returned or exchanged.'],
    footer: true
  },
  DAY_14: {
    paras: ["Decided your piece isn't exactly what you wanted? Send it back.", 'You’ve got 14 days after delivery to send it back to us and get a full refund, minus shipping and a 25% restocking fee.'],
    footer: true
  },
  LIFETIME_DIFFICULTY: {
    paras: ['Every Joybird-manufactured product is covered under a limited lifetime warranty.* This includes most of our upholstered furniture such as sofas, chairs, sectionals, benches, ottomans, daybeds, sleepers and chaises. Warranty coverage does not apply to our home décor items such as pillows, throws, rugs, poufs, wall decor, and lighting. If a repair is needed, we will pay standard rates for the repair, or will provide an alternative solution should the issue be unable to be repaired.', 'Lifetime Limited Warranty* coverage applies to all of the foundational elements of your furniture: wood frames, joints, bases, legs, and hardware, which are integral to the life of your product.', 'Our Three-Year Limited Warranty coverage applies to the springs and bed slats of your product.', 'Our One-Year Limited Warranty coverage applies to any manufacturer’s defects or shipping damage to our fabric, leather, cushioning, seams, tufting, mattresses, wood stains or finishes, mechanical mechanisms found in sleepers and recliners and electrical parts and motors (including battery packs).', '*Clearance items are excluded from all warranty and return policies'],
    footer: true
  },
  LIFETIME_OUTDOOR: {
    paras: ['Our 90-Day Limited Warranty coverage applies to all outdoor products. Outdoor warranty coverage applies to frames, springs, joints, bases, hardware, fabric, foams, seams, tufting, wood stains, finishes, and mechanisms which are integral to the life of your Outdoor product. If a repair is needed, we will pay standard rates for repair, or provide an alternative solution should the item be unable to be repaired.'],
    footer: true
  },
  LIFETIME_CASE_GOODS: {
    paras: ['Our 90-Day Limited Warranty coverage applies to all wood products. This coverage applies to all wood frames, joints, bases, and hardware of our wood products, including desks, wall units, tables, credenzas, office chairs, and bookcases. If a repair is needed, we will pay standard rates for repair, or provide an alternative solution should the item be unable to be repaired.'],
    footer: true
  },
  LIMITED_EDITION: {
    rows: [{
      title: 'This product is part of a special Limited Edition partnership.'
    }],
    terms: 'Promotional discounts do not apply to this Limited Edition piece.',
    footer: true
  },
  AFFIRM_FINANCING: {
    rows: [{
      text: <>
            <div>
              Unlock your exclusive financing offer in seconds with Affirm.
              Rates from 0-36% APR. Payment options through Affirm are subject
              to an eligibility check and are provided by these lending
              partners:
            </div>{' '}
            <Link className="underline" to="https://www.affirm.com/lenders">
              affirm.com/lenders
            </Link>
          </>
    }]
  },
  PREMIUM_IN_HOME_DELIVERY: {
    rows: [{
      title: 'Premium In-Home Delivery',
      text: 'A premium in-home service will deliver your order on a pre-scheduled date. The delivery team will move and unpack your order to the room of your choice and dispose of all packaging. Please note: Not all items are eligible for in-home service. Price dependent on your location.'
    }]
  }
};
export { data };